@if ($output().src) {
    <media-player 
        [src]="$output().src"
        controls
        aspect-ratio="16/9"
        crossorigin="anonymous"
    >
        <media-outlet>
            @if ($output().captions) {
                @for (caption of $output().captions; track caption.src) {
                    <track [src]="caption.src" kind="subtitles" [label]="caption.label" [srclang]="caption.srclang" />
                }
            }
        </media-outlet>
    </media-player>
}